// extracted by mini-css-extract-plugin
export default {"box":"Skills_box__Cdnph","Heading":"Skills_Heading__Pj2iW","skills-card-img":"Skills_skills-card-img__VLosj"};